import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import {
  Table,
  Col,
  Row,
  Container,
  Pagination,
  Modal,
  Button,
} from "react-bootstrap";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import {
  onSnapshot,
  collection,
  query,
  where,
  getDoc,
  doc,
} from "firebase/firestore";
import "./VentasXDias.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function VentasXDia() {
  const { register } = useAuthContext();
  const elementsPerPage = 10;
  const [data, setData] = useState([]);
  const [detalleOrden, setDetalleOrden] = useState([]);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [grafSelected, setGrafSelected] = useState("2");
  const [dataChart, setDataChart] = useState([]);
  const [dataTarde, setDataTarde] = useState([]);
  const [dataFecha, setDataFecha] = useState([]);
  const [dataManana, setDataManana] = useState([]);
  const [hide, setHide] = useState("hidden");
  const [fechaInicial, setFechaInicial] = useState(
    new Date().toISOString().substring(0, 8) + "01"
  );
  const [fechaFinal, setFechaFinal] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [Mes, setMes] = useState(false);
  const [Semana, setSemana] = useState(false);
  const [Dia, setDia] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp.seconds * 1000);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    const turno = date.getHours() >= 12 ? "PM" : "AM";
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const Semana = Math.ceil(
      ((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7
    );
    return {
      date: formattedDate, // Retorna la fecha formateada
      time: formattedTime, // Retorna la hora formateada
      mes: date.toLocaleString("es-MX", { month: "long" }).toUpperCase(),
      año: date.getFullYear(),
      turno: turno,
      semana: Semana,
    };
  };

  const handleFechaInicial = (e) => {
    setFechaInicial(e.target.value);
  };

  function mostrarDetalles(item) {
    setDetalleOrden(item);
    setMostrarDetalle(true);
  }

  const handleFechaFinal = (e) => {
    setFechaFinal(e.target.value);
  };

  const handleChange = (e) => {
    if (e.target.name === "Mes") {
      setMes(true);
      setSemana(false);
      setDia(false);
    } else if (e.target.name === "Semana") {
      setMes(false);
      setSemana(true);
      setDia(false);
    } else if (e.target.name === "Dia") {
      setMes(false);
      setSemana(false);
      setDia(true);
    }
  };

  const handleSelectGraf = (e) => {
    setGrafSelected(e.target.value);
  };

  const HiddenTable = () => {
    if (hide === "hidden") {
      setHide("");
      let elem = document.getElementById("ex-tblChecador");
      elem.hidden = true;
    } else {
      setHide("hidden");
      let elem = document.getElementById("ex-tblChecador");
      elem.removeAttribute("hidden");
    }
  };

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return data.slice(startIndex, endIndex);
  };

  useEffect(() => {
    const events = async () => {
      const fechaI = Date.parse(fechaInicial);
      const fi = new Date(fechaI);
      const fechaF = Date.parse(fechaFinal);
      let ff = new Date(fechaF);
      let ffas = ff.getDate() + 1;
      ff.setDate(ffas);
      const filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        {
          campo: "status",
          operador: "in",
          valor: ["COMPLETADO", "ENTREGAR", "ATENDIDO", ""],
        },
        { campo: "fecha", operador: ">=", valor: fi },
        { campo: "fecha", operador: "<=", valor: ff },
      ];
      let q = query(collection(projectFirestore, "turnero"));
      filtros.forEach((filtro) => {
        const { campo, operador, valor } = filtro;
        q = query(q, where(campo, operador, valor));
      });
      onSnapshot(q, async (docs) => {
        const documentosColeccion = [];
        docs.docs.forEach(async (docss) => {
          const data = docss.data();
          data.id = docss.id;
          if (data.atendio !== "Administrador" && data.atendio) {
            let que = await doc(projectFirestore, "users", data.atendio);
            let hsd = getDoc(que);
            data.atendio = (await hsd).data().fullName;
            documentosColeccion.push(data);
            documentosColeccion.sort((a, b) => a.fecha - b.fecha);
          } else {
            documentosColeccion.push(data);
            documentosColeccion.sort((a, b) => a.fecha - b.fecha);
          }
          setData(documentosColeccion);
          const datosTarde = [];
          const datosManana = [];
          const datosFecha = [];
          const datosChart = [];
          const result = Object.groupBy(documentosColeccion, ({ fecha }) => {
            const { mes, semana, date, año } = formatTimestamp(fecha);
            if (Mes) {
              return mes + " " + año;
            } else if (Semana) {
              return semana + "-" + año;
            } else {
              return date;
            }
          });
          for (const [key, value] of Object.entries(result)) {
            const resultTurno = Object.groupBy(value, ({ fecha }) => {
              const { turno } = formatTimestamp(fecha);
              return turno;
            });
            let ev = [];
            for (const [key, valu] of Object.entries(resultTurno)) {
              let Turno = key;
              let suma = 0;
              valu.forEach((elemen) => {
                suma += elemen.total;
              });
              if (Turno === "PM") {
                datosTarde.push(suma);
              } else {
                datosManana.push(suma);
              }
            }
            if (datosTarde.length > datosManana.length) {
              datosManana.push(0);
            } else if (datosTarde.length < datosManana.length) {
              datosTarde.push(0);
            }
            setDataTarde(datosTarde);
            setDataManana(datosManana);
            let Nombre = key;
            if (Nombre === "undefined") {
              Nombre = "Prueba";
            }
            let sum = 0;
            value.forEach((elemen) => {
              sum += elemen.total;
            });
            datosChart.push({ label: Nombre, value: sum, valoresT: ev });
            datosFecha.push(Nombre);
          }
          setDataFecha(datosFecha);
          setDataTarde(datosTarde);
          setDataManana(datosManana);
          setDataChart(datosChart);
        });
        if (docs.docs.length === 0) {
          setData([]);
          setDataFecha([]);
          setDataTarde([]);
          setDataManana([]);
          setDataChart([]);
        }
      });
      if (grafSelected === "1") {
        let Bars = document.getElementById("GrafBar");
        Bars.hidden = true;
        let Pie = document.getElementById("GrafPie");
        Pie.removeAttribute("hidden");
      } else {
        let Bars = document.getElementById("GrafBar");
        Bars.removeAttribute("hidden");
        let Pie = document.getElementById("GrafPie");
        Pie.hidden = true;
      }
    };
    events();
  }, [Mes, Semana, fechaFinal, fechaInicial, grafSelected, register.id]);

  return (
    <div>
      <h1>Venta por dia y turno</h1>
      <br />
      <Container>
        <Row>
          <Col md={3} className="">
            <h4 className="center" hidden>
              Tipo de grafica
            </h4>
            <Row style={{ margin: "unset !important" }} hidden>
              <br />
              <div className="form-switch">
                <label className="lblFiltro"></label>
                <select value={grafSelected} onChange={handleSelectGraf}>
                  {/* <option value="1">Pastel</option> */}
                  <option value="2">Barras</option>
                </select>
              </div>
            </Row>
            <h4 className="center">Rango de fechas</h4>
            <Row style={{ margin: "unset !important" }}>
              <br />
              <div className="form-switch">
                <label className="lblFiltro"> Fecha inicial</label>
                <input
                  className="form-date"
                  type="date"
                  value={fechaInicial}
                  onChange={handleFechaInicial}
                  name="fechaInicial"
                  id="flexSwitchCheckDefault"
                />
              </div>
              <div className="form-switch">
                <label className="lblFiltro"> Fecha final</label>
                <input
                  className="form-date"
                  type="date"
                  value={fechaFinal}
                  onChange={handleFechaFinal}
                  name="fechaFinal"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <h4 className="center">Periodo</h4>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Mensual</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={Mes}
                  onChange={handleChange}
                  name="Mes"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Semanal</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={Semana}
                  onChange={handleChange}
                  name="Semana"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
            <Row style={{ margin: "unset !important" }}>
              <div className="form-switch">
                <label className="lblFiltro">Diario</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={Dia}
                  onChange={handleChange}
                  name="Dia"
                  id="flexSwitchCheckDefault"
                />
              </div>
            </Row>
          </Col>
          <Col md={1}></Col>
          <Col md={8} id="GrafPie">
            <h4 className="center">Por periodo</h4>
            <PieChart
              series={[
                {
                  arcLabel: (item) => `${item.value}`,
                  arcLabelMinAngle: 20,
                  highlightScope: { faded: "global", highlighted: "item" },
                  faded: {
                    additionalRadius: -50,
                    color: "gray",
                  },
                  data: dataChart,
                },
              ]}
              sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: "white",
                  fontWeight: "bold",
                  fontSize: "20px",
                },
              }}
              width={800}
              height={500}
            />
          </Col>
          <Col md={8} id="GrafBar" hidden>
            <h4 className="center">Por periodo y turno</h4>
            <BarChart
              series={[
                {
                  data: dataTarde,
                  label: "PM",
                },
                {
                  data: dataManana,
                  label: "AM",
                },
              ]}
              layout="vertical"
              barLabel={({ value }) => (value !== 0 ? `$${value}` : ``)}
              xAxis={[{ scaleType: "band", data: dataFecha }]}
              width={800}
              height={500}
            />
          </Col>
        </Row>
        <Col md={4}>
          <div className="form-switch">
            <label className="lblFiltro">Visualizar datos en tabla</label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={hide}
              onChange={HiddenTable}
              name="hide"
              id="flexSwitchCheckDefault"
            />
          </div>
        </Col>
      </Container>
      <Container id="ex-tblChecador">
        <Table striped bordered hover border="2">
          <thead>
            <tr>
              <th>No. Folio</th>
              <th>Atendio</th>
              <th>Fecha</th>
              <th>Tipo de pago</th>
              <th>Total</th>
              <th>Cliente</th>
              <th>Detalles</th>
            </tr>
          </thead>
          <tbody>
            {getElementsForPage(currentPage)
              .sort()
              .map((val, key) => {
                const { date, time } = formatTimestamp(val.fecha);
                return (
                  <>
                    <tr key={key}>
                      <td>{val.folio}</td>
                      <td>{val.atendio}</td>
                      <td>
                        {date} {time}
                      </td>
                      <td>{val.tipo_pago}</td>
                      <td>{val.total}</td>
                      <td>{val.user_name}</td>
                      <td>
                        <Button
                          variant="primary"
                          style={{
                            minWidth: "50px !important",
                            marginLeft: 20,
                          }}
                          onClick={() => {
                            mostrarDetalles(val);
                          }}
                        >
                          <FontAwesomeIcon icon={faBars} />
                        </Button>
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </Table>
        <Pagination>
          {Array.from({
            length: Math.ceil(data.length / elementsPerPage),
          }).map((page, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === currentPage}
              className={index + 1 === currentPage ? "btn-paginado" : ""}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      </Container>
      <Modal
        show={mostrarDetalle}
        onHide={() => {
          setDetalleOrden([]);
          setMostrarDetalle(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Detalles de la Orden</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <strong>Atendio: </strong>
          {detalleOrden.atendio ? detalleOrden.atendio : ""}
          <br />
          <br /> */}
          <Table striped bordered hover border="2">
            <thead>
              <tr>
                <th>Platillo</th>
                <th>Costo</th>
                <th>Cantidad</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {detalleOrden.detalle
                ? detalleOrden.detalle.map((element) => {
                    return (
                      <tr>
                        <td>{element.name.toString()}</td>
                        <td>{parseFloat(element.costo).toFixed(2)}</td>
                        <td>
                          {element.cantidad ? element.cantidad : "SIN NOMBRE"}
                        </td>
                        <td>{element.total.toFixed(2)}</td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setDetalleOrden([]);
              setMostrarDetalle(false);
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
